import { render } from "./HBEOnlinePaymentType.vue?vue&type=template&id=ff4a09e6&scoped=true"
import script from "./HBEOnlinePaymentType.vue?vue&type=script&lang=js"
export * from "./HBEOnlinePaymentType.vue?vue&type=script&lang=js"

import "./HBEOnlinePaymentType.vue?vue&type=style&index=0&id=ff4a09e6&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4a09e6"]])

export default __exports__